<div class="cursos-container">
    <h2 class="section-title">{{ 'COURSES.TITLE' | translate }}</h2>
    <p class="section-subtitle">{{ 'COURSES.SUB_TITLE' | translate }} </p>

<div class="card-grid">
        @for (curso of courses(); track $index) {
        <mat-card class="curso-card" appearance="outlined">
            <mat-card-header>
                <mat-card-title>{{ curso.name | translate}}</mat-card-title>
            </mat-card-header>
            <img mat-card-image [src]="curso.safeResourcePhoto$ | async" (click)="goToLogin()" style="cursor: pointer;"
                [alt]="curso.name">
            <mat-card-content>
                <p>{{ curso.description | translate }}</p>
                <p> {{ curso.professorName | translate }}</p>
                <p> {{ curso.creditMessage | translate }}</p>
            </mat-card-content>

            <mat-card-actions>
                <button matButton (click)="goToLogin()">{{ 'COURSES.REGISTER' | translate }}</button>
            </mat-card-actions>
        </mat-card>
        }
    </div>
</div>